import { render, staticRenderFns } from "./data-share.pug?vue&type=template&id=303f53d1&lang=pug&"
import script from "./data-share.ts?vue&type=script&lang=ts&"
export * from "./data-share.ts?vue&type=script&lang=ts&"
import style0 from "./data-share.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports